import isFilledUp from './fields/isFilledUp'
import isMobileNumber from './fields/isMobileNumber'
import isEmail from './fields/isEmail'
import isPersonName from './fields/isPersonName'
// import isDate from './fields/isDate'
// import isGender from './fields/isGender'
import isReferralCode from './fields/isReferralCode'

const validateFirstName = (name, firstName) => {
  if (!isFilledUp(firstName)) {
    return { [name]: 'First name is required' }
  }
  if (!isPersonName(firstName)) {
    return { [name]: 'First name contains invalid characters' }
  }
  return {}
}

const validateLastName = (name, lastName) => {
  if (!isFilledUp(lastName)) {
    return { [name]: 'Last name is required' }
  }
  if (!isPersonName(lastName)) {
    return { [name]: 'Last name contains invalid characters' }
  }
  return {}
}

const validateEmail = (name, email) => {
  if (!isFilledUp(email)) {
    return { [name]: 'Email is required' }
  }
  if (!isEmail(email)) {
    return { [name]: 'Invalid format for email' }
  }
  return {}
}

// const validateDateOfBirth = (name, birthdate) => {
//   if (!isFilledUp(birthdate)) {
//     return { [name]: 'Birthdate is required' }
//   }
//   if (!isDate(birthdate)) {
//     return { [name]: 'Invalid birthdate' }
//   }
//   return {}
// }

// const validateGender = (name, gender) => {
//   if (!isFilledUp(gender)) {
//     return { [name]: 'Gender is required' }
//   }
//   if (!isGender(gender)) {
//     return { [name]: 'Invalid gender' }
//   }
//   return {}
// }

const validateMobileNumber = (name, mobileNumber) => {
  if (!isFilledUp(mobileNumber)) {
    return { [name]: 'Mobile number is required' }
  }

  if (!isMobileNumber(mobileNumber)) {
    return { [name]: 'Invalid mobile number' }
  }

  return {}
}

const validateReferralCode = (name, referralCode) => {
  if (!isReferralCode(referralCode)) {
    return { [name]: 'Invalid referral code, must be 8-15 characters.' }
  }
  return {}
}

// const validateCaptcha = (name, captcha) => {
//   if (!isFilledUp(captcha)) {
//     return { [name]: 'Captcha is required' }
//   }
//   return {}
// }

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const {
    firstName,
    lastName,
    email,
    mobileNumber,
    referralCode,
    // checkAgreement,
  } = values

  return {
    ...validateFirstName('firstName', firstName),
    ...validateLastName('lastName', lastName),
    ...validateEmail('email', email),
    ...validateMobileNumber('mobileNumber', mobileNumber),
    ...validateReferralCode('referralCode', referralCode),
    // ...validateChecked('checkAgreement', checkAgreement),
  }
}

export default validate
